import { ClientResponseType } from '@brainvaulttech/dgr-react-sdk';
import { InvoiceType } from './accountsReceivable.types';

export enum RecapFileType {
  PDF = 'PDF',
  CSV = 'CSV',
  BOTH = 'BOTH',
}

export enum RecapFrequency {
  WEEKLY = 'WEEKLY',
  NIGHTLY = 'NIGHTLY',
}

export enum StatementFileType {
  PDF = 'PDF',
  CSV = 'CSV',
  BOTH = 'BOTH',
}

export enum FbsFileType {
  PDF = 'PDF',
  CSV = 'CSV',
  BOTH = 'BOTH',
}

export type BillingPreferenceResponse = {
  billingPreferenceId?: string;
  billingType?: InvoiceType;
  isArRequired?: boolean;
  isInvoiceRequired?: boolean;
  isRecapRequired?: boolean;
  recapFileType?: RecapFileType;
  recapFrequency?: RecapFrequency;
  statementFileType?: StatementFileType;
  applyFinancialCharges?: boolean;
  isFbsRequired?: boolean;
  fbsFileType?: FbsFileType;
  createdAt?: Date;
  client?: {
    type: ClientResponseType;
    firstName?: string;
    lastName?: string;
    clientName?: string;
  } | null;
};

export type BillingPreferenceUpdateSchema = {
  billingType?: InvoiceType;
  isArRequired?: boolean;
  isInvoiceRequired?: boolean;
  isRecapRequired?: boolean;
  recapFileType?: RecapFileType | null;
  recapFrequency?: RecapFrequency | null;
  statementFileType?: StatementFileType | null;
  applyFinancialCharges?: boolean;
  isFbsRequired?: boolean;
  fbsFileType?: FbsFileType | null;
};

/** Subset of GET /clients/{id} (`ClientGetByIdResponse`) used by create/edit and invoice-share flows. */
export type ClientByIdResponse = {
  clientId: string;
  code: string;
  clientName: string;
  status?: string;
  type?: ClientResponseType;
  firstName?: string | null;
  lastName?: string | null;
  /** A/R invoice recipient emails (OpenAPI ClientResponse.arInvoices). */
  arInvoices?: string[] | null;
  /** A/R invoice CC emails (OpenAPI ClientResponse.arInvoicesCc). */
  arInvoicesCc?: string[] | null;
};
